const consumerEvents = {
    trackAddToCartEvent: function (trackingData) {
        window.mediator.publish('trackAddToCartProfile', {
            productCode: trackingData.id,
            quantity:    trackingData.quantity,
            cartData:    {
                cartCode:     trackingData.code,
                categories:   trackingData.categoriesAsJsonString,
                productCode:  trackingData.id,
                productName:  trackingData.name,
                productPrice: trackingData.price,
                quantity:     trackingData.quantity
            }
        });
    },

    trackRemoveFromCartEvent: function (trackingData) {
        window.mediator.publish('trackRemoveFromCartProfile', {
            productCode:         trackingData.id,
            initialCartQuantity: trackingData.quantity
        });
    },

    trackUpdateCartEvent: function (trackingData, initialQuantity, newQuantity) {
        window.mediator.publish('trackUpdateCartProfile', {
            productCode:         trackingData.id,
            initialCartQuantity: initialQuantity,
            newCartQuantity:     newQuantity
        });
    }
};

export default consumerEvents;
